module.exports = __webpack_public_path__ + "img/infolibre.fdf3f67e.svg";